module.exports = __webpack_public_path__ + "static/portfolio-3-e4eb6f67cbb71bfed0e51620a77f45cb.jpg";